import { render, staticRenderFns } from "./BindInvoice.vue?vue&type=template&id=202f6d96&scoped=true"
import script from "./BindInvoice.vue?vue&type=script&lang=ts"
export * from "./BindInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f6d96",
  null
  
)

export default component.exports